import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios, { Axios } from 'axios'
import { APIS } from 'constants/api.constant'
import { getApi } from 'services/CommonService'

 
export const fetchCategories = createAsyncThunk(
    'category/fetchCategories',
   async  ({page,limit,search }, { rejectWithValue }) => {
        try {
             const params = new URLSearchParams()

       if (page !== undefined && page !== null) {
    params.append('page', page)
}
        if (limit) params.append('limit', limit)
        if (search) params.append('search', search)

        const res = await getApi(`${APIS.CATEGORIES}?${params.toString()}`)
       
            return res.data
        } catch (err) {
            return (err.response?.data || err.message)
        }
    }
)

const categorySlice = createSlice({
    name: 'category',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.loading = false
                state.data = action.payload
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    },
})

export default categorySlice.reducer